import React from 'react';

import { Paper } from '@hbf/dsl';

interface Props {
  className?: string;
}

const UserCard: React.FC<Props> = ({ children, ...rest }) => (
  <Paper {...rest}>{children}</Paper>
);

export { UserCard };
